<template>
    <!-- {{ singleDataTree }} -->
    <div v-show="isSearchAble">
        <input type="text" placeholder="Search bots" class="searchInput" @keyup="searchSmartTag" />
    </div>
    <div class="innerUl py-2.5 px-2" v-if="isMultiple">
        <VDropdown
            v-for="(item, index) in dataTree"
            :key="index"
            class="multi_dropdown"
            :distance="24"
            :skidding="0"
            placement="auto"
            :prevent-overflow="true"
            :overflow-padding="60"
            auto-boundary-max-size
        >
            <!-- This will be the reference for the dropdown (trigger) -->
            <!-- {{ item }} -->
            <div
                class="multi_dropdown_content"
                :class="[
                    item.heading ? 'pointer-events-none' : item.seperator ? 'pointer-events-none !p-0 !h-auto' : '',
                ]"
            >
                <!-- [info]: not sure what this could be. leaving it as it is for now -->
                <template v-if="item.subnav && item.subnav.length > 0">
                    <h4 class="text-xs font-bold text-gray-navtext" v-if="item.heading === true">
                        {{ item.title }}
                    </h4>
                    <div class="bg-gray-200 h-[0.0625rem] my-2.5 w-full" v-else-if="item.seperator === true"></div>
                    <div v-else class="flex items-center w-full">
                        <fa v-if="item.icon" :icon="['fal', item.icon]"></fa>
                        <p>{{ item.title }}</p>
                        <fa class="ml-auto !text-[0.625rem]" :icon="['fal', 'angle-right']"></fa>
                    </div>
                </template>
                <template
                    v-else
                    :class="[item.heading ? 'pointer-events-none' : item.seperator ? 'pointer-events-none !p-0' : '']"
                >
                    <h4 class="text-xs font-bold text-gray-navtext" v-if="item.heading === true">
                        {{ item.title }}
                    </h4>
                    <div class="bg-gray-200 h-[0.0625rem] my-2.5 w-full" v-else-if="item.seperator === true"></div>
                    <div v-else class="w-full">
                        <button @click="handleClick(item)" class="flex items-center w-full">
                            <fa v-if="item.icon" :icon="['fal', item.icon]" class="text-lg mr-1"></fa>
                            <p>{{ item.title }}</p>
                            <fa
                                class="!ml-auto !text-[0.625rem]"
                                :icon="['fal', 'angle-right']"
                                v-if="item.subnav && item.subnav.length > 0"
                            ></fa>
                        </button>
                    </div>
                </template>
            </div>
            <!-- This will be the content of the dropdown -->
            <template #popper>
                <div v-if="item.subnav && item.subnav.length > 0" class="multi_dropdown__child">
                    <InboxPopperDropdown :dataTree="item.subnav" @handleClick="handleClickMethod"></InboxPopperDropdown>
                </div>
                <div v-else>
                    <!-- Content for items without sub-navigation -->
                    <div v-for="(child, childIndex) in item.child" :key="childIndex">
                        <fa v-if="child.icon" :icon="['fal', child.icon]"></fa>
                        <p>{{ child.title }}</p>
                    </div>
                </div>
            </template>
        </VDropdown>
    </div>

    <div class="innerUl py-2.5 px-2" v-else="isSubSearch">
        <VDropdown
            v-for="(item, index) in dataTree"
            :key="index"
            class="multi_dropdown"
            :distance="24"
            :skidding="0"
            placement="auto"
            :prevent-overflow="true"
            :overflow-padding="60"
            auto-boundary-max-size
        >
            <!-- This will be the reference for the dropdown (trigger) -->
            <!-- {{ item }} -->
            <div
                class="multi_dropdown_content"
                :class="[
                    item.heading ? 'pointer-events-none' : item.seperator ? 'pointer-events-none !p-0 !h-auto' : '',
                ]"
            >
                <template v-if="item.subnav && item.subnav.length > 0">
                    <h4 class="text-xs font-bold text-gray-navtext" v-if="item.heading === true">
                        {{ item.title }}
                    </h4>
                    <div class="bg-gray-200 h-[0.0625rem] my-2.5 w-full" v-else-if="item.seperator === true"></div>
                    <div v-else class="flex items-center w-full">
                        <fa v-if="item.icon" :icon="['fal', item.icon]"></fa>
                        <p>{{ item.title }}</p>
                        <fa class="ml-auto !text-[0.625rem]" :icon="['fal', 'angle-right']"></fa>
                    </div>
                </template>
                <template
                    v-else
                    :class="[item.heading ? 'pointer-events-none' : item.seperator ? 'pointer-events-none !p-0' : '']"
                >
                    <h4 class="text-xs font-bold text-gray-navtext" v-if="item.heading === true">
                        {{ item.title }}
                    </h4>
                    <div class="bg-gray-200 h-[0.0625rem] my-2.5 w-full" v-else-if="item.seperator === true"></div>
                    <div v-else>
                        <button @click="handleClick(item)" class="flex items-center w-full">
                            <fa v-if="item.icon" :icon="['fal', item.icon]" class="text-lg text-gray-navtext mr-1"></fa>
                            <p>{{ item.title }}</p>
                            <fa
                                class="!ml-auto !text-[0.625rem]"
                                :icon="['fal', 'angle-right']"
                                v-if="item.subnav && item.subnav.length > 0"
                            ></fa>
                        </button>
                    </div>
                </template>
            </div>
            <!-- This will be the content of the dropdown -->
            <template #popper>
                <div v-if="item.subnav && item.subnav.length > 0" class="multi_dropdown__child subSearch">
                    <input type="text" placeholder="Search activities" class="searchInput" @keyup="" />
                    <div class="p-4">
                        <template v-for="(subItem, index) in item.subnav" :key="index">
                            <div v-if="subItem.heading === true">
                                <h4 class="text-xs font-bold text-gray-navtext p-2 uppercase h-10 flex items-center">
                                    {{ item.title }}
                                </h4>
                            </div>
                            <div v-else>
                                <button
                                    @click="handleClick(item)"
                                    class="flex items-center w-full h-10 p-2 hover:bg-gray-100 rounded"
                                >
                                    <AppLabel
                                        classes="badge pink mr-1"
                                        :text="subItem.title"
                                        suffixIcon="chevron-right"
                                    ></AppLabel>
                                    <p class="text-xs text-gray-500">@ 54 Manor house SE14</p>
                                </button>
                            </div>
                        </template>
                    </div>
                </div>
                <div v-else>
                    <!-- Content for items without sub-navigation -->
                    <div v-for="(child, childIndex) in item.child" :key="childIndex">
                        <fa v-if="child.icon" :icon="['fal', child.icon]"></fa>
                        <p>{{ child.title }}</p>
                    </div>
                </div>
            </template>
        </VDropdown>
    </div>
</template>

<script setup>
import { ref, watch } from "vue";
import EmojiPicker from "vue3-emoji-picker";
import { useSettingStore } from "@/stores/settingStore.js";
import "vue3-emoji-picker/css";
const emit = defineEmits(["handleClick", "SearchTag"]);
import { findParentPath } from "@/composables/globals";
import AppLabel from "@/components/AppLabel.vue";
const settingStore = useSettingStore();
const props = defineProps({
    dataTree: {
        type: Array,
        required: false,
    },
    singleDataTree: {
        type: Array,
        required: false,
    },
    isSearchAble: {
        type: Boolean,
        required: false,
        default: false,
    },
    showPopper: {
        type: Boolean,
        default: false,
    },
    headingText: {
        type: String,
        default: "",
    },
    subHeadingText: {
        type: String,
        default: "",
    },
    isHeading: {
        type: Boolean,
        default: false,
    },
    smartClass: {
        type: String,
        default: "",
    },
    isMultiple: {
        type: Boolean,
        default: true,
    },
    isSubSearch: {
        type: Boolean,
    },
    type: {
        type: String,
        default: "",
        required: false,
    },
    sendBotMessage: {
        type: Function,
        default: () => null,
    },
});

// handle click emit
const handleClick = (value) => {
    console.log("handle click popper called");
    emit("handleClick", value);

    props?.sendBotMessage(value.id);
};
const onSelectEmoji = (emoji) => {
    if (props.type === "add") {
        settingStore.newResponseDetail.detail_info = settingStore.getNewCannedResponse.detail_info + emoji.i;
    } else {
        settingStore.editCannedResponse.detail_info = settingStore.getEditCannedResponse.detail_info + emoji.i;
    }
};
const handleClickMethod = (value) => {
    if (props.isMultiple) {
        const pathToItem = findParentPath(props.dataTree, value.levels);
        emit("pathToItemClick", pathToItem);
        console.log(pathToItem, value, "handleClickMethod");
    }
    emit("handleClick", value);
};
const searchSmartTag = (v) => {
    emit("SearchTag", v);
};
watch(
    () => props.singleDataTree,
    () => {
        group_arrey();
    },
);

const dropdownSingle = ref([]);
const groupedArray = ref([]);

const group_arrey = () => {
    if (props.singleDataTree) {
        dropdownSingle.value = [...props.singleDataTree];
        // Create an object to store grouped values
        const groupedData = {};

        // // Iterate through the data and group by title
        dropdownSingle.value.forEach((item) => {
            const { type, ...items } = item;
            if (!groupedData[type]) {
                groupedData[type] = [];
            }
            groupedData[type].push(items);
        });

        // // Convert the grouped object into an array of objects
        groupedArray.value = Object.keys(groupedData).map((type) => ({
            type,
            values: groupedData[type],
        }));
    }
};
group_arrey();

// console.log(groupedArray,'group_arrey');
</script>

<style scoped>
.searchInput {
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512" fill="%23BAC4CD"><path d="M368 208A160 160 0 1 0 48 208a160 160 0 1 0 320 0zM337.1 371.1C301.7 399.2 256.8 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 48.8-16.8 93.7-44.9 129.1L505 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L337.1 371.1z"/></svg>');
    background-position: 16px 16px;
    background-repeat: no-repeat;
    padding: 16px 16px 16px 42px;
    @apply !text-sm !text-dark-100 !h-[3.0625rem] outline-none border-b border-gray-200 w-full;
}

.multi_dropdown {
    @apply mb-0.5;
}

.multi_dropdown .multi_dropdown_content {
    @apply p-2 h-10 flex cursor-pointer items-center hover:bg-gray-100 rounded-lg;
}

.multi_dropdown_content svg {
    @apply text-lg text-[#abb4bc] mr-1;
}

.multi_dropdown_content p {
    @apply text-sm text-dark-100 italic;
}

.v3-emoji-picker {
    @apply h-[350px] w-[330px];
}
.subSearch .innerUl {
    @apply !p-4;
}
</style>
